
import React, { useDebugValue, useEffect, useRef, useState } from "react";
import ireland_json from './ireland.json'
import nireland_json from './nireland.json'
import InfoPanel from '../InfoPanel.js'

import "./Map.css"
import { useContext } from '../Context.js';
import * as d3 from 'd3';
import { useTranslation } from 'react-i18next';

const HEADER_PADDING = 66;
const NI_PADDING = 50;

const renderMap = (ref, selected, onCountyClick, language, {data, countyInfo}, onOrgSelect) => () => {

  const orgsLogosHandler = (logoSize) => ({countyID, countyIndex}) => {
    if (countyID === 'N/A') countyID = 'DUBLIN'
    let [px, py] = projection(d3.geoCentroid(countyIDToFeature[countyID]))
    let total = countyInfo[countyID]
    let side = Math.ceil(Math.sqrt(total))

    let cellN = (countyIndex - 1) % side
    let rowN = (countyIndex -1 - cellN) / side
    let adjLogoSize = 1.1 * logoSize
    let marginX = - adjLogoSize * ((side - 1)  / 2)
    let marginY = - adjLogoSize * ((countyInfo[countyID]/ side - 1)  / 2)

    px += marginX + cellN * adjLogoSize 
    py += marginY + rowN * adjLogoSize
    if (countyIndex > side * (side - 1)) {
      px += (side * side - total) * adjLogoSize / 2
    }
    return !Number.isNaN(px) ? `translate(${px}, ${py})` : ''
  }
  const rectHandler = (logoSize, rects) => {
    rects.attr("width", `${logoSize}px`).attr("height", `${logoSize}px`)
    .attr("x", `-${logoSize/2}px`).attr("y", `-${logoSize/2}px`)
    .attr('rx', `${logoSize* 0.1}px`)
    .attr('ry', `${logoSize* 0.1}px`)
    .attr('fill', 'white')
  }
  const countyIDToFeature = {}
  ireland_json.features.forEach((data, index) => {
    const {properties: {COUNTY}} = data
    countyIDToFeature[COUNTY] = data
  })
  const [mapWidth, mapHeight] = [900, 1170] 
  const projection = d3.geoMercator().fitSize([mapWidth, mapHeight], ireland_json)

  let svg = d3.select(ref.current).selectAll('svg');
  svg.remove();

  svg = d3.select(ref.current).append('svg')
    .attr('height', `100%`)
    .attr('width', '100%')
    .attr("preserveAspectRatio", "xMidYMid meet")
    .attr("viewBox", `50 0 ${mapWidth} ${mapHeight}`)
    
    .classed("svg-content-responsive", true)

    svg.append("defs")
    .append('filter')
      .attr('id','shadow')
      .append('feDropShadow')
        .attr('dx', 1).attr('dy', 1).attr('stdDeviation', 0.2)
  // Creating path generator fromt the projecttion created above.
  const pathGenerator = d3.geoPath().digits(0)
    .projection(projection);

  // Creating the container
  const g = svg.append("g")
    .attr('class', 'center-container center-items us-state')
  // Creating counties layer
  const countiesGroup = g.append("g")
    .attr("id", "сounties")
    .selectAll("path")
    .classed("county", true)
    .data(ireland_json.features)
    .enter();
  const northerIrelandGroup = g.append('g')
    .selectAll('path').data(nireland_json.features).enter();
  
  northerIrelandGroup
    .append('path')
    .attr('d', pathGenerator)
    .classed("county-ni", true)

  const orgsGroup = g.append("g")
    .attr("id", "org-group")
    .selectAll("g")
    .data(data)
    .enter()
  let logoSize = 60
  let orgsGroupG = orgsGroup.append("g")
  orgsGroupG.classed("org-logo-map", true)
  let bgRects = orgsGroupG.append("rect").attr('filter', 'url(#shadow)')
  rectHandler(logoSize,bgRects)

  orgsGroupG
    .attr("transform", orgsLogosHandler(logoSize))
    .append('image')
      .attr("href", d => d.img)
      .attr("width", `${logoSize}px`)
      .attr("height", `${logoSize}px`)
      .attr('y', `${-logoSize/2}px`)
      .attr('x', `${-logoSize/2}px`)

  orgsGroupG.on('click', (event, {countyID, id}) => {
    countyID = countyID === 'N/A' ? 'DUBLIN' : countyID
    onCountyClick(countyIDToFeature[countyID]);
    onOrgSelect(id)

  });
  orgsGroup.exit().remove()

  countiesGroup
    .append("path")
    .attr("key", feature => {
      return feature.properties.COUNTY
    })
    .attr("d", (data) => {
      return pathGenerator(data)
    })
    .attr("id", (data) => data.properties.COUNTY)
    .attr("class", "county")
    .classed('county-active', d => !d.properties.IS_NI && d.properties.COUNTY === selected?.properties?.COUNTY)
    .on('click', (event, d) => {
      onCountyClick(d);
    });


  return () => {
    d3.selectAll(ref.current).selectAll('.county')
      .classed('county-active', d => !d.properties.IS_NI && d.properties.COUNTY === selected?.properties?.COUNTY)
      ;
  }
}

export default function Map({orgs}) {
  const ref = useRef(null);
  const {map: {onCountyClick, selected, selectOrg}} = useContext();
  const { i18n: {language} } = useTranslation();

  // eslint-disable-next-line
  useEffect(() => {
    if ( !ref || !ref.current) return () => {}
    return renderMap(ref, selected, onCountyClick, language, orgs, selectOrg)()
  }, [language, orgs, ref]);
  useEffect(() => {
    d3.select(ref.current)
      .selectAll('.county').classed('county-active', d => !d.properties.IS_NI && d.properties.COUNTY === selected?.properties?.COUNTY)
  }, [selected])
  return (
    <>
      <div className="viz" id="map" ref={ref} ></div>
      <InfoPanel orgs={orgs}/>
      <p className="copyright">© 2026, Ukrainian Action in Ireland.<br/>This work is licensed under <a href="https://creativecommons.org/licenses/by/4.0/" style={{fontSize: "10px"}}>CC BY 4.0</a>
      <img src="https://mirrors.creativecommons.org/presskit/icons/cc.svg" alt="" style={{"max-height":"1vh","margin-left": "1px"}} />
      <img src="https://mirrors.creativecommons.org/presskit/icons/by.svg" alt="" style={{"max-height":"1vh","margin-left": "1px"}}></img></p>
    </>
  );
}